<mat-card class="cur-card" *ngIf="gamenHyojiInfo">
    <mat-card-header>
        <mat-card-title>返金結果登録</mat-card-title>
    </mat-card-header>
    <form (ngSubmit)="onRegist()" [formGroup]="szmf033aRequestForm">
        <mat-card-content>
            <div [formGroup]="repayReportInfDto">
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金額</mat-label>
                        <input matInput id="repayMny" class="font-color-display-only text-right"
                            [value]="gamenHyojiInfo.basicInfo.repayMny | number" disabled />
                        <span matSuffix>円</span>
                    </mat-form-field>
                </div>

                <h2>返金先口座情報</h2>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金方法</mat-label>
                        <input matInput id="rpaytokouzaRepaywayCode" class="font-color-display-only" autocomplete="off"
                            [value]="gamenHyojiInfo.rpaytoKouza.repayMethod.aname" readonly="true" disabled />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座名義（漢字）</mat-label>
                        <input matInput id="kohuriVisitActknj" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.kohuriActknj" disabled />
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座名義（カナ）</mat-label>
                        <input matInput id="kouzaMeigiKana" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.kouzaMeigiKana" disabled />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>金融機関コード</mat-label>
                        <input matInput id="extBankfcCode" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.bankfc.codeValue" disabled />
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>支店コード</mat-label>
                        <input matInput id="extBranchCode" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.branch.codeValue" disabled />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field [appearance]="'fill'"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>金融機関名</mat-label>
                        <input matInput id="bankfcAname" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.bankfc.aname" readonly="true" disabled />
                    </mat-form-field>
                    <mat-form-field [appearance]="'fill'"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>支店名</mat-label>
                        <input matInput id="branchAname" readonly="true" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.branch.aname" disabled />
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>預金種別</mat-label>
                        <input matInput id="dptKitem" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.dptClsfy.aname" disabled />
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>口座番号</mat-label>
                        <input matInput id="kouzaNo" class="font-color-display-only"
                            [value]="gamenHyojiInfo.rpaytoKouza.kouzaNo" disabled />
                    </mat-form-field>
                </div>

                <h2>返金元口座情報</h2>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金元口座設定</mat-label>
                        <input matInput id="refundsourceKouzaCode" class="font-color-display-only"
                            [value]="gamenHyojiInfo.refundsourceKouza.refundsourcekouzaSetting.aname" disabled />
                    </mat-form-field>
                </div>

                <h2>返金結果登録情報</h2>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金日</mat-label>
                        <input matInput [matDatepicker]="repayFinDate" formControlName="repayFinDate" autocomplete="off"
                            [required]=true maxlength="10">
                        <mat-datepicker-toggle matSuffix [for]="repayFinDate"></mat-datepicker-toggle>
                        <mat-datepicker #repayFinDate></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                        <mat-label>返金完了区分</mat-label>
                        <mat-select formControlName="repayStateDiv" (selectionChange)="onChangeSelect($event.value)"
                            [required]=true>
                            <mat-option *ngFor="let type of repayStateDivList" [value]="type.value">{{type.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                    <mat-card-actions class="btn_area_right">
                        <button type="submit" mat-raised-button color="primary" [disabled]="repayReportInfDto.invalid"
                            class="btn">登録</button>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card-content>
    </form>
</mat-card>